// extracted by mini-css-extract-plugin
module.exports = {"container":"ErrorModal_container__BgWn4","title":"ErrorModal_title__8KWNE","message":"ErrorModal_message__NlrFq","footer":"ErrorModal_footer__JvDRx"};